import React, { useState } from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Axios from 'axios'
import Cookies from 'universal-cookie'

// Cookies
const cookies = new Cookies()

export default function PasswordChange(props) {
    const [oldPassword, setOldPassword] = useState(null)
    const [newPassword, setNewPassword] = useState(null)
    const [repeatPassword, setRepeatPassword] = useState(null)
    const [passwordNotEqual, setPasswordNotEqual] = useState(false)
    const [wrongPassword, setWrongPassword] = useState(false)
    const [success, setSuccess] = useState(false)

    const handleOldPassword = (e) => {
        setOldPassword(e.target.value)
    }
    const handleNewPassword = (e) => {
        setNewPassword(e.target.value)
    }
    const handleRepeatPassword = (e) => {
        setRepeatPassword(e.target.value)
    }

    const handleForm = (e) => {
        setPasswordNotEqual(false)
        setWrongPassword(false)
        e.preventDefault()
        if (newPassword !== repeatPassword) {
            setPasswordNotEqual(true)
            return
        }
        Axios.post(props.base_url + 'endpoint/account', { api_key: props.api_key, old_password: oldPassword, new_password: newPassword, email: cookies.get('email'), operation: 'password_change' })
            .then(res => {
                if (res.data === 'Incorrect password') {
                    setWrongPassword(true)
                }
                else {
                    setSuccess(true)
                    Axios.post(props.base_url + 'endpoint/login', { username: cookies.get('email'), password: newPassword, operation: 'sign_in' })
                        .then(res => {
                            cookies.remove('dataUser')
                            cookies.set('dataUser', res.data.dataUser, { path: '/' })
                            window.location.href = "/"
                        })

                }
            })
    }

    return (
        <>
            {!success &&
                <Form onSubmit={handleForm}>
                    <Form.Group controlId="oldPassword">
                        <Form.Control type="password" placeholder="Contraseña anterior" onChange={handleOldPassword} style={wrongPassword ? { borderColor: 'red' } : {}} />
                    </Form.Group>
                    <Form.Group controlId="newPassword">
                        <Form.Control type="password" placeholder="Nueva contraseña" onChange={handleNewPassword} style={passwordNotEqual ? { borderColor: 'red' } : {}} />
                    </Form.Group>
                    <Form.Group controlId="repeatPassword" >
                        <Form.Control type="password" placeholder="Repetir contraseña" onChange={handleRepeatPassword} style={passwordNotEqual ? { borderColor: 'red' } : {}} />
                    </Form.Group>

                    <Button variant="primary" type="submit">Confirmar</Button>
                </Form>
            }
            {passwordNotEqual
                && <p className='text-danger'>Las contraseñas no coinciden</p>
            }
            {success &&
                <p className="text-success">La contraseña se ha cambiado correctamente</p>
            }
            {wrongPassword &&
                <p className="text-danger">La contraseña actual es incorrecta</p>
            }
        </>
    )
}